






































import {Component, Prop, Ref, Vue} from "vue-property-decorator";
import Paging, {PagingQueryForm} from 'biz-ts/src/api/Paging';
import Pagination from '@/component/Pagination/index.vue'
import {Table} from "element-ui";

@Component({
  components: {
    Pagination
  }
})
export default class PaginationTable extends Vue {

  @Prop() protected defaultExpandAll!: boolean
  @Prop({default: false, type: Boolean}) protected selectable!: boolean

  @Ref() table!: Table

  @Prop() protected pqForm!: PagingQueryForm
  @Prop() protected getPaging!: (() => Promise<Paging<unknown>>)
  @Prop({default: 'id'}) protected rowKey!: string | ((row: unknown) => string)

  @Prop({
    default: () => {
      return {autoload: true}
    }
  })
  protected cfg!: { autoload: boolean }

  private paging = new Paging<unknown>()
  private loading = false

  private async innerGetPaging() {
    this.loading = true
    this.paging = await this.getPaging()
        .finally(() => {
          this.loading = false
        })
  }

  private async created() {
    if (this.cfg.autoload)
      await this.innerGetPaging()
  }

  reset() {
    this.paging = new Paging<unknown>()
  }

  async refresh() {
    await this.innerGetPaging()
    this.table.doLayout()
  }
}
